<template>
    <div class="border-darken-1 mt-2">
          <div class="d-flex align-items-end row">
            <div class="col-7">
              <div class="text-nowrap">
                <template v-if="userStore.user.is_contract_signed">
                    <h5 class="title mb-0" style="text-transform: capitalize;">Client Agreement</h5>
                    <br>
                    <p class="mb-2" v-if="userStore.profile.user">Signed Agreement</p>
                    <p class="mb-2" v-if="!userStore.profile.user && userStore.user.isClient">You Signed an Agreement with <span style="font-weight:bolder;">{{ userStore.user.company_name }}</span></p>
                    <a href="javascript:;" class="btn btn btn-outline-primary waves-effect waves-light mr-2" @click="userStore.agreementType=2,openModal(`#${contract_element}`)" v-if="userStore.user.contract">View Agreement</a>
                    <a href="javascript:;" class="btn btn-primary waves-effect waves-light " @click="downloadContract(1)">Download Agreement</a>
                </template>
                <template v-else>
                    <p class="title mb-0" style="text-transform: capitalize;">{{userStore.user.firstname}} {{userStore.user.lastname}} </p>
                    <p class="mb-2" v-if="userStore.profile.user">Has Not Signed The Agreement</p>
                    <p class="mb-2" v-if="!userStore.profile.user && userStore.user.isClient">You Have Not Signed the Agreement {{ userStore.user.company_name }}</p>
                </template>
                <template v-if="userStore.user.is_power_of_attorney_signed">
                    <h5 class="title mb-0  mt-2" style="text-transform: capitalize; mt-2">Power Of Attorney</h5>
                    <br>
                    <p class="mb-2" v-if="userStore.profile.user">Signed Power Of Attorney</p>
                    <p class="mb-2" v-if="!userStore.profile.user && userStore.user.isClient">You Signed Power Of Attorney</p>
                    <a href="javascript:;" class="btn btn btn-outline-primary waves-effect waves-light mr-2" @click="userStore.agreementType=2,openModal(`#${contract_element}`)" v-if="userStore.user.contract">View Power Of Attorney</a>
                    <a href="javascript:;" class="btn btn-primary waves-effect waves-light " @click="downloadContract(2)">Download Power Of Attorney</a>
                </template>
                <template v-else>
                    <p class="title mb-0 mt-2" style="text-transform:capitalize;">Power Of Attorney</p>
                    <p class="mb-2" v-if="userStore.profile.user">Has Not Signed The Power Of Attorney</p>
                    <p class="mb-2" v-if="!userStore.profile.user && userStore.user.isClient">You Have Not Signed The Power Of Attorney</p>
                </template>

              </div>
            </div>
          </div>
      </div>
      <client-contract-modal :id="contract_element"></client-contract-modal>
</template>
<script>
import {reactive } from 'vue'
import { useUserStore } from '../../stores/UserStore.js'
import ClientContractModal  from '../modals/ClientContractModal.vue'
import { closeModal, hideModal, openModal } from '../../utilities/_helpers'
import Swal from 'sweetalert2'

export default{
    components:{
        ClientContractModal
    },
    setup(props){
        return{
            contract_element:'contract-preview',
            userStore:useUserStore(),
            openModal:openModal
        }
    },
    mounted(){

    },
    methods: {
        downloadContract(type){
            let $this = this;
            Swal.fire({
                title: 'Client Contract',
                html: `<span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span> Contract Generation is in Progress`,
                showConfirmButton: false,
                allowOutsideClick: false
            });
            const route = this.$router.resolve(
                {
                    name: 'download-contract',
                    params:{
                        client: this.$route.params.client ? this.$route.params.client : this.userStore.user.id,
                        type: type,
                        team: this.$route.params.team,
                    }
                }
            );
            axios.get(route.href,{
                responseType: 'blob',
            })
            .then(response => {
                if(response.data) {
                    Swal.close();
                }
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `contract_${$this.userStore.user.firstname}_${$this.userStore.user.lastname}.pdf`);
                document.body.appendChild(link);
                link.click();
                return;
            })
            .catch(function (error) {
                console.error('Error converting HTML to PDF:', error);
            });
        }
    },
}
</script>
